import * as React from 'react';
const ZoomIn = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-zoom-in", ...props },
    React.createElement("circle", { cx: "11", cy: "11", r: "8" }),
    React.createElement("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" }),
    React.createElement("line", { x1: "11", y1: "8", x2: "11", y2: "14" }),
    React.createElement("line", { x1: "8", y1: "11", x2: "14", y2: "11" })));
export default ZoomIn;
//# sourceMappingURL=ZoomIn.js.map